<template>
  <div class="search">
    <div v-if="focused" class="bg" @click="focused = false">
      <div onclick="event.stopPropagation()" class="wrapper"></div>

      <div v-if="searchQuery.length > 2" class="datalist">
        <div v-if="!searchHints.length" class="no-match">
          <span>Ничего не найдено</span>
        </div>
        <ul v-else>
          <nuxt-link
            v-for="(item, i) in searchHints"
            :to="`/film/${item.pretty}`"
            :key="`sh-${i}`"
            tag="li"
          >
            <div class="poster">
              <!-- <img :data-src="item.poster" src="/static_files/no-poster.png" alt="" class="lazyload"> -->
              <nuxt-img
                :src="`/static_files/uploads/posters/${item.id}.webp`"
                :alt="`${item.title} / ${item.title_orig}`"
                fit="cover"
                loading="lazy"
                width="50px"
                format="webp"
                quality="70"
              />
            </div>
            <p>
              <strong>{{ item.title }}</strong>
              <span v-if="item.year">{{ item.year }}</span>
              <span v-if="item.genres"> {{ item.genres.slice(0, 3).join(', ') }}</span>
            </p>
          </nuxt-link>
        </ul>
      </div>
    </div>
    <div class="input">
      <div class="wrap">
        <div class="search-icon"></div>
        <input
          id="search"
          ref="search"
          v-model="searchQuery"
          :class="{ active: searchQuery }"
          @input="trottled"
          @click="focused = true"
          type="search"
          name="search"
          autocomplete="off"
          placeholder="Начните вводить название..."
        >
        <template v-if="searchQuery || !isDesktop">
          <div class="vline"></div>
          <div @click="clearQuery" class="clear-icon"></div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  watch: {
    changeRoute() {
      this.searchQuery = ''
      this.searchHints = []
    },
    focused(val) {
      if (val) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
      }
    },
  },
  computed: {
    ...mapState(['isDesktop']),
    changeRoute() {
      return this.$route.fullPath
    },
  },
  data() {
    return {
      focused: false,
      searchQuery: '',
      searchHints: [],
    }
  },
  methods: {
    clearQuery() {
      this.searchQuery = ''
      this.searchHints = []
      this.$emit('close')
    },
    trottled() {
      if (!this.searchQuery.trim()) return
      let oldValue = ''
      setTimeout(() => {
        if (
          oldValue === this.searchQuery &&
          this.searchQuery !== '' &&
          this.searchQuery.length > 2
        ) {
          this.getSearchHints()
        }
      }, 200)
      oldValue = this.searchQuery
    },
    async getSearchHints() {
      const { data } = await this.$axios.post(`/api/search`, { value: this.searchQuery, })

      if (data.error) {
        this.$store.commit('setError', { status: 'warn', msg: data.error.message })
        setTimeout(() => this.$store.commit('clearError'), 2000)
      } else {
        this.searchHints = data
      }
    }
  }
}
</script>

<style lang="stylus">
.search
  .bg
    position: fixed
    top: 0px
    left: 0px
    width: 100%
    height: 100%
    background-color: rgba(0, 0, 0, 0.4) // rgba(77,92,116, 0.8)
    z-index: 1
    .wrapper
      width: 100%
      height: 80px
      background-color: #fff
    .datalist
      position: absolute
      padding-bottom: 100px
      top: 90px
      left: calc(50% - 250px)
      width: 500px
      max-height: 60vh
      background-color: #fff
      border-radius: 12px
      overflow-x: hidden
      overflow-y: auto
      .no-match
        padding: 15px
        span
          font-weight: 400
      ul
        li
          display: grid
          grid-template-columns: 50px auto
          grid-gap: 10px
          padding: 10px 15px
          transition: all 0.2s ease
          cursor: pointer
          .poster
            width: 50px
            height: 50px
            border-radius: 12px
            overflow: hidden
            img
              width: 100%
              height: auto
              object-fit: cover
          &:hover
            background-color: rgba(238, 114, 3, 0.12)
            strong
              color: #ee7203
        p
          text-align: left
          strong
            display: block
            font-size: 1.6rem
          span
            display: inline-block
            font-size: 1.4rem
            opacity: 0.65
  .input
    position: relative
    z-index: 2
    .wrap
      position: relative
      .search-icon
        display: inline-block
        position: absolute
        top: 12px
        left: 12px
        width: 18px
        height: 18px
        background-image: url('/static_files/icons/search.svg')
        background-size: 18px
        opacity: 0.5
      .vline
        display: inline-block
        position: absolute
        top: 8px
        right: 38px
        width: 1px
        height: 24px
        background-color: #e9e9e9 // rgba(0, 0, 0, 0.15)
      .clear-icon
        display: inline-block
        position: absolute
        top: 15px
        right: 15px
        width: 12px
        height: 12px
        background-image: url('/static_files/icons/close.svg')
        background-size: 12px
        opacity: 0.5
        cursor: pointer
        &:hover
          opacity: 1
      input
        padding: 8px 12px 8px 34px
</style>
